import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Gallery = (props) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <div
            className="gallery-container"
            onClick={() => {
                props.onClose();
            }}
        >
            <button className="close-button" onClick={props.onClose}>
                &times;
            </button>
            <div
                className="gallery-inner"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {props.images !== undefined &&
                    props.images !== null &&
                    props.images.length !== 0 && (
                        <Slider
                            {...settings}
                            className="slider-container"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            {props.images.map((item, index) => (
                                <div
                                    key={item.id}
                                    className="product-card"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <div className="img-div">
                                        <img src={item.image} alt="" />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    )}
            </div>
        </div>
    );
};
export default Gallery;
